import * as React from "react";
import * as classNames from "classNames";

export interface ISVGiconProps extends React.Props<SVGicon> {
    icon: ISVGiconData;
    width?: number;
    height?: number;
    className?: string;
}

export interface ISVGiconState {}

export interface ISVGiconData {
    name: string;
    viewBox: string;
    data: string;
}

//////////////////////
//  Add icons here  //
//////////////////////

export interface ISVGiconIcons {
    chevronLeft: ISVGiconData;
    chevronRight: ISVGiconData;
    chevronUp: ISVGiconData;
    chevronDown: ISVGiconData;
    filePdf: ISVGiconData;
    close: ISVGiconData;
    exit: ISVGiconData;
    upload: ISVGiconData;
    creditCard: ISVGiconData;
    comparison: ISVGiconData;
    heart: ISVGiconData;
    chart: ISVGiconData;
    hamburgerMenu: ISVGiconData;
    tick: ISVGiconData;
    info: ISVGiconData;
    paperPencil: ISVGiconData;
    piggyBank: ISVGiconData;
    smartphone: ISVGiconData;
    bulb: ISVGiconData;
    potentialHigh: ISVGiconData;
    realisticReturn: ISVGiconData;
    potentialLow: ISVGiconData;
    mailUs: ISVGiconData;
    savingsHand: ISVGiconData;
    xMark: ISVGiconData;
    barChart: ISVGiconData;
    first: ISVGiconData;
    computerClick: ISVGiconData;
    person: ISVGiconData;
    policy: ISVGiconData;
    phoneChat: ISVGiconData;
    phone: ISVGiconData;
    placePoint: ISVGiconData;
}

export const svgIcons: ISVGiconIcons = {
    // Keep this in sync with the Styleguide!
    /* tslint:disable:max-line-length */
    chevronLeft: {
        name: "chevron-left",
        viewBox: "0 0 7 12",
        data: `<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 1L1 6L6 11"/>`,
    },

    chevronRight: {
        name: "chevron-right",
        viewBox: "0 0 7 12",
        data: `<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1L6 6L1 11"/>`,
    },

    chevronUp: {
        name: "chevron-up",
        viewBox: "0 0 12 7",
        data: `<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 6L6 1L11 6"/>`,
    },

    chevronDown: {
        name: "chevron-down",
        viewBox: "0 0 12 7",
        data: `<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1L6 6L11 1"/>`,
    },

    filePdf: {
        name: "file-pdf",
        viewBox: "0 0 55 63",
        data: `
            <path d="M27.6 23.39c-1.088 6.12-3.917 12.493-5.223 15.808-4.678 11.09-12.947 6.756-1.85.127a34.178 34.178 0 0 1 11.86-4.207c11.533-1.785 7.18 7.904.653 1.912-2.394-2.167-5.005-3.824-6.964-10.07-4.025-12.749 3.156-12.494 1.524-3.57z" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5"/>
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2 13v48h51V2H13L2 13h11V2"/>
        `,
    },

    close: {
        name: "close",
        viewBox: "0 0 16 16",
        data: `<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2 2l12 12M2 14L14 2" />`,
    },

    exit: {
        name: "exit",
        viewBox: "0 0 20 20",
        data: `<path fill="none" stroke="currentColor" stroke-width="2" d="M11 6l0 -5l-10 0l0 18l10 0l0 -5  M6 10l10 0  M18 10l-2 -2l0 4z" />`,
    },

    upload: {
        name: "upload",
        viewBox: "0 0 60 45",
        data: `
            <g fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="3">
                <path d="M57.5 22v16.5a4 4 0 0 1-4 4h-47a4 4 0 0 1-4-4V22"  />
                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M30 25.625V3m-7.625 7.625L30 3l7.625 7.625" />
            </g>
        `,
    },

    creditCard: {
        name: "credit-card",
        viewBox: "0 0 29 21",
        data: `
            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10">
                <rect x="1.5" y="1.5" width="26" height="18" rx="2" ry="2"/>
                <path stroke-width="3" stroke-linecap="butt" d="M1.5 5.5814h26"/>
                <path d="M4 10.5h4M3.5 14.5h13M3.5 16.5h7M9.8333 10.5h4M15.6667 10.5h4M21.5 10.5h4"/>
            </g>
        `,
    },

    comparison: {
        name: "comparison",
        viewBox: "0 0 30 25",
        data: `<path fill="none" stroke="currentColor" stroke-miterlimit="10" d="M2.1 9.3h16.5V12a.7.7 0 0 0 .6.7.7.7 0 0 0 .4-.1l8.6-5a.7.7 0 0 0 0-1.1l-8.6-5a.7.7 0 0 0-.4-.1.7.7 0 0 0-.3 0 .7.7 0 0 0-.3.7V5H2a.6.6 0 0 0-.6.6v3a.6.6 0 0 0 .6.7zm25.8 6.5H11.4V13a.7.7 0 0 0-.6-.7.7.7 0 0 0-.4.1l-8.6 5a.7.7 0 0 0 0 1.1l8.6 5a.7.7 0 0 0 .4.1.7.7 0 0 0 .3 0 .7.7 0 0 0 .3-.7v-2.8H28a.6.6 0 0 0 .6-.6v-3a.6.6 0 0 0-.6-.7z"/>`,
    },

    heart: {
        name: "heart",
        viewBox: "0 0 36 33",
        data: `<path fill="none" stroke="currentColor" stroke-miterlimit="10" d="M18 5.4a9.3 9.3 0 0 1 9.8-2c6.5 2.5 5.7 9.6 5.7 9.6a19.6 19.6 0 0 1-3.5 8.6c-3.1 4.8-12 9.8-12 9.8a43 43 0 0 1-11-8.5C2.5 17.6 2.7 13 2.7 13a9.4 9.4 0 0 1 4.8-9.2C13.1.5 18 5.4 18 5.4z"/>`,
    },

    chart: {
        name: "chart",
        viewBox: "0 0 32 32",
        data: `<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M29.5 30.5h-28v-28a1 1 0 0 1 1-1 1 1 0 0 1 1 1v26h26a1 1 0 0 1 1 1 1 1 0 0 1-1 1z M3.6 16.2l5.6 4.7 4.1-6.1 4 6 8-8.1 M20 12.5h5.3a.2.2 0 0 1 .2.2V18"/>`,
    },

    hamburgerMenu: {
        name: "hamburger-menu",
        viewBox: "0 0 26 19",
        data: `<path fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" d="M2 2.5l22 0 M2 9.5l22 0 M2 16.5l22 0"/>`,
    },

    tick: {
        name: "tick",
        viewBox: "0 0 18 15",
        data: `<path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M2 9l3.5 4l10 -11"/>`,
    },

    info: {
        name: "info",
        viewBox: "0 0 4 16",
        data: `<path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M2 2l0 0 M2 6l0 10"/>`,
    },

    paperPencil: {
        name: "paper-pencil",
        viewBox: "0 0 37 35",
        data: `<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M11.5 7.5h10M11.5 13.5h10M11.5 26.5h10M11.5 20.5h7M31.4 15.6V33a.5.5 0 0 1-.5.5H6.1a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h24.8a.5.5 0 0 1 .5.5v9.6M25 22l10-10a2.2 2.2 0 0 0-2-2L23 20zm-2-2l-2 4 4-2"/>`,
    },

    piggyBank: {
        name: "piggy-bank",
        viewBox: "0 0 30 35",
        data: `
            <path d="M22 5.6A4.1 4.1 0 1 0 18 9.8 4.1 4.1 0 0 0 22 5.6z" fill="none" stroke="currentColor" stroke-miterlimit="10"/>
            <path d="M19.3 5.8a.9.9 0 0 0-.3-.3 1.5 1.5 0 0 0-.4-.2 3.4 3.4 0 0 0-.4-.2h-.4a2.9 2.9 0 0 1-.4-.2.8.8 0 0 1-.3-.1.4.4 0 0 1 0-.3.6.6 0 0 1 0-.3.5.5 0 0 1 .2-.2.8.8 0 0 1 .2-.1 1.7 1.7 0 0 1 .4 0 1 1 0 0 1 .6.1.8.8 0 0 1 .3.6h.4a1.4 1.4 0 0 0 0-.5 1.2 1.2 0 0 0-.4-.4 1.2 1.2 0 0 0-.4-.2 2.7 2.7 0 0 0-.3 0v-.7h-.3v.6a2.2 2.2 0 0 0-.4.1 1.3 1.3 0 0 0-.5.2 1 1 0 0 0-.4.8.8.8 0 0 0 .4.7 1.4 1.4 0 0 0 .4.2h.4l.5.2a2.1 2.1 0 0 1 .3.1.8.8 0 0 1 .3.2.5.5 0 0 1 .1.3.6.6 0 0 1 0 .3.6.6 0 0 1-.3.3 1 1 0 0 1-.3 0 2 2 0 0 1-.3 0 1.7 1.7 0 0 1-.4 0 1 1 0 0 1-.4-.1.8.8 0 0 1-.2-.3.8.8 0 0 1-.1-.4h-.5a1.3 1.3 0 0 0 .1.6 1 1 0 0 0 .4.4 1.6 1.6 0 0 0 .5.2 2.4 2.4 0 0 0 .4.1V8h.3v-.6a2.4 2.4 0 0 0 .4 0 1.6 1.6 0 0 0 .4-.2 1.1 1.1 0 0 0 .4-.4 1.1 1.1 0 0 0 0-1zM8.8 17.2a1 1 0 1 0 1 1 1 1 0 0 0-1-1z" fill="currentColor"/>
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" d="M13.9 14.3h6.8"/>
            <path d="M28.5 21.6a7.4 7.4 0 0 0-.2-1.7 7.6 7.6 0 0 0-.4-1.3l-.5-.8c-2-3.4-6.4-5.7-11.3-5.7a16.2 16.2 0 0 0-2.7.3.5.5 0 0 1-.4-.2c-1.3-1.7-4-2.7-7.2-2.7a.4.4 0 0 0-.3.2 3 3 0 0 0 .5 1 .1.1 0 0 0 0 .1 14.8 14.8 0 0 1 1.7 3.5.5.5 0 0 1-.2.5 9.7 9.7 0 0 0-2.8 3.1.5.5 0 0 1-.4.3H1.9a.4.4 0 0 0-.4.3v6.2a.4.4 0 0 0 .4.3h2.4a.5.5 0 0 1 .4.3 8.2 8.2 0 0 0 2.2 2.5.4.4 0 0 1 .2.2l1.1 5.2a.4.4 0 0 0 .4.3h5a.4.4 0 0 0 .3-.4V31a.4.4 0 0 1 .2-.4.5.5 0 0 1 .4 0 13.5 13.5 0 0 0 3.3 0 .5.5 0 0 1 .5.4V33a.4.4 0 0 0 .3.4h5a.4.4 0 0 0 .3-.3l.9-5.1a.5.5 0 0 1 .3-.4c2.2-1 3.4-3.1 3.4-6.1z" fill="none" stroke="currentColor" stroke-miterlimit="10"/>
        `,
    },

    smartphone: {
        name: "smartphone",
        viewBox: "0 0 23 35",
        data: `<path d="M20 33.5H3A1.5 1.5 0 0 1 1.5 32V3A1.5 1.5 0 0 1 3 1.5h17A1.5 1.5 0 0 1 21.5 3v29a1.5 1.5 0 0 1-1.5 1.5zm-.5-8.5V5A1.5 1.5 0 0 0 18 3.5H5A1.5 1.5 0 0 0 3.5 5v20A1.5 1.5 0 0 0 5 26.5h13a1.5 1.5 0 0 0 1.5-1.5zM11 28.5a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>`,
    },

    bulb: {
        name: "bulb",
        viewBox: "0 0 36 40",
        data: `<path d="M17.2 28.8a33 33 0 0 0-.7-6.4c-.8-3.5-1.3-4.2-1.3-4.2a4.2 4.2 0 0 0 2.8 1 4.2 4.2 0 0 0 2.8-1s-.5.7-1.2 4.2a52.7 52.7 0 0 0-.8 6.4m3.7.1h-9a.3.3 0 0 1-.3-.3 10 10 0 0 0-1.9-6.1 8 8 0 0 1-1.8-5.1A8.4 8.4 0 0 1 18 9a8.4 8.4 0 0 1 8.5 8.3 8 8 0 0 1-1.8 5 9.9 9.9 0 0 0-1.8 6.2.3.3 0 0 1-.4.3zm-8.7 1.7a.7.7 0 1 0 0 1.4h8.4a.7.7 0 1 0 0-1.4zm0 3.1a.7.7 0 1 0 0 1.4h8.4a.7.7 0 1 0 0-1.4zm4.1 4.8a.9.9 0 0 1-.8-.8v-.8a.2.2 0 0 1 .2-.2h1.3a.2.2 0 0 1 .2.2v.8a.9.9 0 0 1-.9.8zm-.4-32v-5m-11 15h-5m28 0h5m-21-10.4l-1-2.3M7.3 12L5 11m23.2 1l2.4-1M22 6l1-2.2M10.5 9.5l-4-4m19 4l4-4" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>`,
    },

    potentialHigh: {
        name: "potential-high",
        viewBox: "0 0 38 32",
        data: `<path d="M2 27L6 23L14 30L24 2L30 10L33 3L36 6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />`,
    },

    realisticReturn: {
        name: "realistic-return",
        viewBox: "0 0 38 32",
        data: `<path d="M2 20L4 16L12 28L20 3L28 24L32 19L36 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />`,
    },

    potentialLow: {
        name: "potential-low",
        viewBox: "0 0 38 32",
        data: `<path d="M2 6L5 9L7 6L12 12L19 2L28 30L33 24L36 29" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />`,
    },

    mailUs: {
        name: "mail-us",
        viewBox: "0 0 36 21",
        data: `<path fill="none" stroke="currentColor" stroke-miterlimit="10" d="M1 3.5h8m-8 14h8m-5-7h10m20.5-7a2 2 0 0 0-2-2h-20a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h20a2 2 0 0 0 2-2v-14zM11.1 2.1L21 12c.5.5 2.5.5 3 0L34 2M11 19l8.5-8.5m14.4 8.4l-8.4-8.4" />`,
    },

    savingsHand: {
        name: "savings-hand",
        viewBox: "0 0 31 29",
        data: `<path fill="none" stroke="currentColor" stroke-miterlimit="10" d="M20.5 1.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm8.7 19.9c-.3.4-2.9 1.4-5.4 2.4l-5.6 2.3c-.3 0-3.2-.8-5.6-1.7l-.5-.1c-2-.3-4.4-.1-4.6-.1v-6.8l3.2-.2 2.5-.2c.7 0 1.5.4 2.3.6l1.3.5 1.4.3c.6.1 1.2.2 1.7.5.4.2.8.6.7 1 0 .3-.4.6-.8.7-1.7.4-2.3.2-5.5-.6l-.7-.1H13c-.2 0-.3.3-.2.5.2.5.8.5 1.3.6l.9.2c1.7.4 2.8.6 4.1.5 1.1 0 2.6-.8 2.9-.9 2.6-1 3.9-1.4 5.2-1.6.8-.2 1.9.4 2.1.8.2.3.3.8-.1 1.4zM7.1 14.5c.2 0 .4.2.4.4v12.2c0 .2-.2.4-.4.4H1.9a.4.4 0 0 1-.4-.4V14.9c0-.2.2-.4.4-.4h5.2zM14.5 7a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm9 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-18 15a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z" />`,
    },

    xMark: {
        name: "x-mark",
        viewBox: "0 0 28 28",
        data: `<path fill="none" stroke="currentColor" stroke-miterlimit="10" d="M5.3 2.2a.7.7 0 0 0-1 0l-2 2.1c-.4.3-.4.7 0 1l8.6 8.7-8.7 8.7c-.3.3-.3.7 0 1l2 2a.7.7 0 0 0 1.1 0l8.7-8.6 8.7 8.7a.7.7 0 0 0 1 0l2-2a.7.7 0 0 0 0-1.1L17.2 14l8.7-8.7.2-.5c0-.2 0-.4-.2-.5l-2.1-2a.7.7 0 0 0-1 0L14 10.8 5.3 2.2z" />`,
    },

    barChart: {
        name: "bar-chart",
        viewBox: "0 0 31 32",
        data: `<path fill="none" stroke="currentColor" stroke-miterlimit="10" d="M5.5 30.5h-4v-18h4v18zm8-29h-4v29h4v-29zm8 7h-4v22h4v-22zm8 11h-4v11h4v-11z"/>`,
    },

    first: {
        name: "first",
        viewBox: "0 0 27 25",
        data: `
            <text x="16" y="21" font-size="25" text-anchor="end">1</text>
            <text x="13" y="21" font-size="12" text-anchor="start">st</text>
        `,
    },

    computerClick: {
        name: "computer-click",
        viewBox: "0 0 550.1 550.1",
        data: `
    <style>.st0{fill:none;stroke:currentColor;stroke-width:16.5;stroke-miterlimit:10}</style>
    <path class="st0" d="M415.2 262.5c1.4.2 2.6 1.3 3.1 2.7.4 1.4.1 2.9-.9 4l-13 13.3 22.9 22.4c1.6 1.5 1.6 4 .1 5.6l-15.5 15.9c-.7.7-1.7 1.2-2.8 1.2-1 0-2-.4-2.7-1.1l-22.9-22.4-13 13.3c-1 1-2.5 1.4-3.9 1-1.4-.4-2.4-1.6-2.7-3l-11.2-58c-.2-1.3.2-2.6 1.1-3.5.9-.9 2.2-1.3 3.5-1.1l57.9 9.7z"/>
    <path class="st0" d="M472.8 376.5H77.2c-2.1 0-3.7-1.7-3.7-3.7V142.4c0-19.3 15.7-35.1 35.1-35.1h332.9c19.3 0 35.1 15.7 35.1 35.1v230.4c-.1 2-1.7 3.7-3.8 3.7z"/>
    <path class="st0" d="M439.3 349.5H110.8c-5.1 0-9.3-4.2-9.3-9.3V143.7c0-5.1 4.2-9.3 9.3-9.3h328.5c5.1 0 9.3 4.2 9.3 9.3v196.5c0 5.1-4.2 9.3-9.3 9.3zM497.2 442.7H52.9c-18.3 0-33.1-14.9-33.1-33.1 0-18.3 14.9-33.1 33.1-33.1h444.3c18.3 0 33.1 14.9 33.1 33.1 0 18.2-14.9 33.1-33.1 33.1z"/>
    <path fill="none" stroke="currentColor" stroke-width="16.5" stroke-linecap="round" stroke-miterlimit="10" d="M247.4 409.6h55.3"/>
    `,
    },

    person: {
        name: "person",
        viewBox: "0 0 550.1 550.1",
        data: `
    <style>.st0,.st1{stroke:currentColor;stroke-miterlimit:10}.st0{stroke-width:16.5;fill:none}.st1{fill:currentColor}</style>
    <path class="st0" d="M381.7 171.6c-1.2 4.8-2.6 9.5-4 14.3-21.5 71.8-64.5 138.6-102.7 138.6-39.6 0-96.8-66-112.2-152.3C148 89.3 160.6 19.8 275 19.8c113.3 0 123.2 87.7 106.7 151.8z"/>
    <path class="st0" d="M378.4 180.4s21 20 24.2 41.8c3.1 21.6-7.2 50.6-7.7 58.3-1.1 15.4 16.3 24.7 16.3 24.7s-6.3 9.9-38.3 1.7-40.7-17.6-40.7-17.6M161 159.6s45.8-124.4 66.7-128.8 17.6 38.5 47.3 59.4c13 9.1 44 10.9 64.9 20.9 26.9 12.9 42.9 33 42.9 33"/>
    <path class="st1" d="M386.2 344.3c.3.1.7.1 1 .3-.4-.1-.7-.2-1-.3zM163.5 344.3c.3 0 .6.1.9.1-.3-.1-.6-.1-.9-.1zM161.5 344.6c.3-.1.7-.2 1-.3-.3.1-.7.2-1 .3zM165.4 344.7zM382.4 345.2c.3-.2.5-.3.8-.5-.2.1-.5.3-.8.5zM384.2 344.4c.3-.1.6-.1.9-.1-.2 0-.6 0-.9.1zM383.3 344.7c.3-.1.6-.3 1-.3-.4.1-.7.2-1 .3zM385.2 344.3h1c-.4 0-.7-.1-1 0zM162.5 344.3c.3-.1.7-.1 1 0-.3-.1-.7 0-1 0zM166.2 345.2c.3.2.5.4.8.7-.2-.3-.5-.5-.8-.7zM381.7 345.9c.2-.3.5-.5.8-.7-.3.2-.6.4-.8.7zM164.4 344.4c.3.1.7.2 1 .3-.3-.1-.6-.2-1-.3z"/>
    <path class="st0" d="M530.8 509s.5 7.4-5.9 14.9c-6.4 7.4-16 7.4-16 7.4H41s-9.6-1.1-16-7.4-5.8-14.9-5.8-14.9l-.5-74.5s-.1-6.4 5.2-16 17-15.6 17-15.6l127.6-65L275 481.7 381.4 338 509 402.5s11.7 5.4 17 15c5.3 9.6 4.4 17 4.4 17l.4 74.5z"/>
    `,
    },

    policy: {
        name: "policy",
        viewBox: "0 0 550.1 550.1",
        data: `
            <style>.st0,.st1{fill:none;stroke:currentColor;stroke-width:16.5;stroke-miterlimit:10}.st1{stroke-linecap:round}</style>
            <path class="st0" d="M238.3 125.1c-2.8 0-5.1 2.3-5.1 5.1v55.7c0 2.8 2.3 5.1 5.1 5.1h54.4c2.8 0 5.1-2.3 5.1-5.1v-55.7c0-2.8-2.3-5.1-5.1-5.1h-54.4z"/>
            <path class="st1" d="M489.5 129.8H334.4M489.5 186.5H334.4M489.5 243.2H243.1M489.5 299.9H259.6M489.5 356.6H242M489.5 413.3H242M189.2 350.5s-12.1 11.4-19.8 15.8c-7.7 4.4-14.3 1.1-18.7 2.2-4.4 1.1-12.6 9.8-12.6 9.8l-70.3-69.9s90.6-89.4 96.1-91.6 25.3 0 25.3 0V274"/>
            <path class="st0" d="M100.2 427.8c-3 0-5.9-1.1-8.2-3.4l-69.1-69.1c-4.5-4.5-4.5-11.8 0-16.3l29.8-29.8c4.5-4.5 11.8-4.5 16.3 0l69.1 69.1c4.5 4.5 4.5 11.8 0 16.3l-29.8 29.8c-2.2 2.3-5.2 3.4-8.1 3.4z"/>
            <path class="st0" d="M103.6 386.1c1 1 1 2.7 0 3.8-.5.5-1.2.8-1.9.8s-1.4-.3-1.9-.8c-1-1-1-2.7 0-3.8 1-1.1 2.7-1.1 3.8 0M189.2 268.4V78c0-2.3 1.9-4.3 4.3-4.3H526c2.3 0 4.3 1.9 4.3 4.3v335.6c0 61.6-53.8 60.5-56.1 60.5H141.9c-2.3 0 47.3 0 47.3-60.5v-64.9"/>
            <path class="st1" d="M189.2 350.9s4.4-28 8.8-30.8 44-7.7 44-7.7 17.6-2.2 17.6-19.8-17.6-18.7-17.6-18.7h-71.5l-19.8 17.6"/>
            `,
    },

    phoneChat: {
        name: "phone-chat",
        viewBox: "0 0 35 36",
        data: `
    <g fill="currentColor" fill-rule="nonzero">
        <path d="M23 31.165c0 .294-.054.678-.163 1.151a6.49 6.49 0 0 1-.343 1.12c-.23.544-.893 1.121-1.993 1.73-1.024.556-2.037.834-3.039.834-.294 0-.582-.02-.865-.057a6.712 6.712 0 0 1-.94-.204 14.005 14.005 0 0 1-.767-.237c-.17-.06-.471-.172-.907-.335a34.804 34.804 0 0 0-.8-.294 14.795 14.795 0 0 1-2.86-1.356c-1.382-.86-2.82-2.036-4.312-3.528-1.492-1.492-2.668-2.93-3.528-4.313a14.795 14.795 0 0 1-1.356-2.859c-.033-.098-.13-.364-.294-.8a64.328 64.328 0 0 1-.335-.907c-.06-.168-.139-.424-.237-.767a6.712 6.712 0 0 1-.204-.94A6.483 6.483 0 0 1 0 18.538c0-1.002.278-2.015.833-3.039.61-1.1 1.187-1.764 1.732-1.993a6.49 6.49 0 0 1 1.119-.343c.473-.109.857-.163 1.151-.163.153 0 .267.016.343.049.196.065.485.48.866 1.241.12.207.283.501.49.883.207.38.398.727.572 1.037.174.31.343.602.506.874.033.043.128.18.286.408.158.229.275.422.351.58.077.158.115.313.115.466 0 .217-.156.49-.466.816-.31.327-.648.627-1.013.899-.365.272-.702.56-1.012.866-.31.305-.466.555-.466.751 0 .098.027.22.082.368.054.147.1.258.138.334.039.077.115.207.23.392.114.186.176.29.187.31.828 1.493 1.775 2.772 2.842 3.84 1.068 1.067 2.347 2.014 3.84 2.842.02.01.124.073.31.188.185.114.315.19.392.229.076.038.187.084.334.138.147.055.27.082.368.082.196 0 .446-.155.751-.466.305-.31.594-.647.866-1.012s.572-.703.899-1.013c.326-.31.599-.466.816-.466.153 0 .308.038.466.115.158.076.351.193.58.35.229.159.365.254.408.287.272.163.564.332.874.506.31.174.656.365 1.037.572.382.207.676.37.883.49.762.381 1.176.67 1.241.866.033.076.049.19.049.343zM30.286 6.181c0 1.12-.385 2.153-1.154 3.103-.77.95-1.82 1.7-3.15 2.252-1.33.551-2.776.827-4.34.827-.703 0-1.423-.065-2.16-.194a10.407 10.407 0 0 1-3.413 1.546c-.294.072-.646.137-1.056.193h-.036a.387.387 0 0 1-.252-.097.397.397 0 0 1-.141-.253.243.243 0 0 1-.013-.079.47.47 0 0 1 .007-.078.253.253 0 0 1 .024-.073l.03-.06.044-.066.049-.06.055-.061.05-.054c.04-.049.134-.15.282-.302.147-.153.253-.272.319-.356.065-.085.157-.202.276-.35a3.05 3.05 0 0 0 .307-.465c.086-.161.17-.338.252-.531-1.015-.58-1.813-1.292-2.394-2.137C13.29 8.04 13 7.139 13 6.18c0-1.118.385-2.153 1.154-3.102.77-.95 1.819-1.7 3.149-2.252C18.633.276 20.08 0 21.643 0c1.563 0 3.01.276 4.34.827 1.33.551 2.38 1.302 3.149 2.252.769.95 1.154 1.984 1.154 3.102zM35 9.272c0 .966-.29 1.87-.872 2.71-.58.841-1.379 1.552-2.394 2.131.082.193.166.37.252.531.086.161.188.316.307.465l.276.35c.066.085.172.204.32.357a8.492 8.492 0 0 1 .33.356l.056.06a.515.515 0 0 1 .05.06c.02.029.034.05.042.067l.03.06.025.073.007.078-.013.079a.446.446 0 0 1-.16.265.374.374 0 0 1-.27.085c-.409-.057-.76-.121-1.055-.194a10.407 10.407 0 0 1-3.413-1.545c-.737.129-1.457.193-2.16.193-2.219 0-4.15-.53-5.796-1.593.475.032.835.048 1.08.048 1.319 0 2.583-.181 3.794-.543 1.212-.362 2.292-.882 3.241-1.558 1.024-.74 1.81-1.593 2.358-2.56a6.117 6.117 0 0 0 .54-4.9c1.056.57 1.89 1.287 2.504 2.148.614.861.921 1.787.921 2.777z"/>
    </g>
    `,
    },

    phone: {
        name: "phone",
        viewBox: "0 0 23 23",
        data: `
    <path d="M23 18.165c0 .294-.054.678-.163 1.151a6.49 6.49 0 0 1-.343 1.12c-.23.544-.893 1.121-1.993 1.73-1.024.556-2.037.834-3.039.834-.294 0-.582-.02-.865-.057a6.712 6.712 0 0 1-.94-.204 14.005 14.005 0 0 1-.767-.237c-.17-.06-.471-.172-.907-.335a34.804 34.804 0 0 0-.8-.294 14.795 14.795 0 0 1-2.86-1.356c-1.382-.86-2.82-2.036-4.312-3.528-1.492-1.492-2.668-2.93-3.528-4.313a14.795 14.795 0 0 1-1.356-2.859c-.033-.098-.13-.364-.294-.8a64.328 64.328 0 0 1-.335-.907c-.06-.168-.139-.424-.237-.767a6.712 6.712 0 0 1-.204-.94A6.483 6.483 0 0 1 0 5.538c0-1.002.278-2.015.833-3.039C1.443 1.4 2.02.735 2.565.506A6.49 6.49 0 0 1 3.684.163C4.157.054 4.54 0 4.835 0c.153 0 .267.016.343.049.196.065.485.48.866 1.241.12.207.283.501.49.883.207.38.398.727.572 1.037.174.31.343.602.506.874.033.043.128.18.286.408.158.229.275.422.351.58.077.158.115.313.115.466 0 .217-.156.49-.466.816-.31.327-.648.627-1.013.899-.365.272-.702.56-1.012.866-.31.305-.466.555-.466.751 0 .098.027.22.082.368.054.147.1.258.138.334.039.077.115.207.23.392.114.186.176.29.187.31.828 1.493 1.775 2.772 2.842 3.84 1.068 1.067 2.347 2.014 3.84 2.842.02.01.124.073.31.188.185.114.315.19.392.229.076.038.187.084.334.138.147.055.27.082.368.082.196 0 .446-.155.751-.466.305-.31.594-.647.866-1.012s.572-.703.899-1.013c.326-.31.599-.466.816-.466.153 0 .308.038.466.115.158.076.351.193.58.35.229.159.365.254.408.287.272.163.564.332.874.506.31.174.656.365 1.037.572.382.207.676.37.883.49.762.381 1.176.67 1.241.866.033.076.049.19.049.343z" fill="currentColor" fill-rule="nonzero"/>
    `,
    },

    placePoint: {
        name: "place-point",
        viewBox: "0 0 16 25",
        data: `
    <path d="M12 8.333c0-1.15-.39-2.132-1.172-2.946-.781-.813-1.724-1.22-2.828-1.22-1.104 0-2.047.407-2.828 1.22C4.39 6.201 4 7.183 4 8.333c0 1.15.39 2.132 1.172 2.946C5.953 12.093 6.896 12.5 8 12.5c1.104 0 2.047-.407 2.828-1.22C11.61 10.464 12 9.483 12 8.332zm4 0c0 1.183-.172 2.154-.516 2.914L9.797 23.844c-.167.358-.414.64-.742.847a1.948 1.948 0 0 1-2.11 0 1.851 1.851 0 0 1-.726-.847L.516 11.247C.172 10.487 0 9.517 0 8.333c0-2.3.781-4.264 2.344-5.892C3.906.814 5.792 0 8 0c2.208 0 4.094.814 5.656 2.441C15.22 4.07 16 6.033 16 8.333z" fill="currentColor" fill-rule="nonzero"/>
    `,
    },
    /* tslint:enable:max-line-length */
};

//////////////////////

export class SVGicon extends React.Component<ISVGiconProps, ISVGiconState> {
    private _svgRef: SVGElement;

    constructor(props: ISVGiconProps) {
        super(props);
        this.state = {};
    }

    public componentDidMount(): void {
        this._svgRef.setAttribute("focusable", "false");
    }

    public render(): JSX.Element {
        const { className, width, height, icon } = this.props;

        return (
            <svg
                className={classNames("svgicon", "svgicon-" + icon.name, className)}
                viewBox={icon.viewBox}
                width={this.getWidth(icon, width)}
                height={this.getHeight(icon, height)}
                aria-hidden="true"
                dangerouslySetInnerHTML={{ __html: this.props.icon.data }}
                ref={(svg: SVGElement) => (this._svgRef = svg)}
            />
        );
    }

    private getWidth(icon: ISVGiconData, width: number): number {
        if (width) {
            return width;
        }

        const coords = icon.viewBox.split(" ");
        // tslint:disable-next-line:radix
        return parseInt(coords[2]);
    }

    private getHeight(icon: ISVGiconData, height: number): number {
        if (height) {
            return height;
        }

        const coords = icon.viewBox.split(" ");
        // tslint:disable-next-line:radix
        return parseInt(coords[3]);
    }
}
